var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.66675V16.0001C20 17.4667 18.8 18.6667 17.3333 18.6667H2.66663V8.00008C2.66663 5.05341 5.05329 2.66675 7.99996 2.66675H20Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 18.6667V22.6667C29.3333 24.8801 27.5466 26.6667 25.3333 26.6667H24C24 25.2001 22.8 24.0001 21.3333 24.0001C19.8666 24.0001 18.6666 25.2001 18.6666 26.6667H13.3333C13.3333 25.2001 12.1333 24.0001 10.6666 24.0001C9.19996 24.0001 7.99996 25.2001 7.99996 26.6667H6.66663C4.45329 26.6667 2.66663 24.8801 2.66663 22.6667V18.6667H17.3333C18.8 18.6667 20 17.4667 20 16.0001V6.66675H22.4533C23.4133 6.66675 24.2933 7.18676 24.7733 8.01343L27.0533 12.0001H25.3333C24.6 12.0001 24 12.6001 24 13.3334V17.3334C24 18.0667 24.6 18.6667 25.3333 18.6667H29.3333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 29.3333C12.1394 29.3333 13.3333 28.1394 13.3333 26.6667C13.3333 25.1939 12.1394 24 10.6667 24C9.19391 24 8 25.1939 8 26.6667C8 28.1394 9.19391 29.3333 10.6667 29.3333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 29.3333C22.8061 29.3333 24 28.1394 24 26.6667C24 25.1939 22.8061 24 21.3333 24C19.8605 24 18.6666 25.1939 18.6666 26.6667C18.6666 28.1394 19.8605 29.3333 21.3333 29.3333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 16V18.6667H25.3333C24.6 18.6667 24 18.0667 24 17.3333V13.3333C24 12.6 24.6 12 25.3333 12H27.0533L29.3333 16Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.faa59aff45187049a5edc816ac8b1e99.svg";
export { ForwardRef as ReactComponent };